import { useQuery } from "@tanstack/react-query";
import { getBilant } from "@/api/endpoints/bilant";
import { queryKeys } from "@/lib/queryClient";
import type { GetBilantResponse } from "@/api/types/bilant";

export function useGetBilant(cui: string | undefined) {
  return useQuery<GetBilantResponse, Error>({
    queryKey: queryKeys.bilant.byCui(cui || ""),
    queryFn: () => getBilant({ cui: cui! }),
    enabled: Boolean(cui && cui.length >= 2),
  });
}
